import { createFileRoute, Link } from "@tanstack/react-router";
import { Rocket, Star } from "lucide-react";
import { ReviewForm } from "@/components/ReviewForm";

export const Route = createFileRoute("/review")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      { title: "Leave a Review — Three Day Launch" },
      { name: "description", content: "Share your experience working with Three Day Launch. Your feedback helps us grow and helps other business owners decide." },
      { property: "og:title", content: "Leave a Review — Three Day Launch" },
      { property: "og:description", content: "Share your experience working with Three Day Launch." },
      { property: "og:url", content: "https://threedaylaunch.com/review" },
    ],
    links: [{ rel: "canonical", href: "https://threedaylaunch.com/review" }],
  }),
  component: ReviewPage,
});

function ReviewPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="mx-auto max-w-4xl px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-primary-gradient flex items-center justify-center">
              <Rocket className="h-4 w-4 text-white" />
            </div>
            <span className="font-bold">Three Day Launch<sup className="text-[0.6em] ml-0.5">®</sup></span>
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Back home</Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-16">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-primary">
            <Star className="h-3.5 w-3.5" /> Three Day Launch Review
          </div>
          <h1 className="mt-4 text-4xl md:text-5xl font-bold tracking-tight">Tell us how it went</h1>
          <p className="mt-4 text-muted-foreground text-lg">
            We'd love to hear about your experience working with Three Day Launch.
          </p>
        </div>

        <div className="mt-10">
          <ReviewForm />
        </div>
      </main>

      <footer className="bg-secondary text-secondary-foreground border-t border-white/10 py-10 mt-16">
        <div className="mx-auto max-w-7xl px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-primary-gradient flex items-center justify-center">
              <Rocket className="h-4 w-4 text-white" />
            </div>
            <span className="font-bold">Three Day Launch<sup className="text-[0.6em] ml-0.5">®</sup></span>
          </div>
          <div className="text-sm text-white/80">© {new Date().getFullYear()} Three Day Launch.</div>
        </div>
      </footer>
    </div>
  );
}
